import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'
import HomeView from '@/views/HomeView.vue'
import LoginView from '@/views/LoginView.vue'
import GalleryView from '@/views/GalleryView.vue'
import SettingsView from '@/views/SettingsView.vue'

import UsersView from '@/views/users/UsersView.vue'
import UsersEdit from '@/views/users/UsersEdit.vue'
import UsersUpload from '@/views/users/UsersUpload.vue'

import NewsView from '@/views/news/NewsView.vue'
import NewsEdit from '@/views/news/NewsEdit.vue'
import NewsUpload from '@/views/news/NewsUpload.vue'

import HoroView from '@/views/horo/HoroView.vue'
import HoroEdit from '@/views/horo/HoroEdit.vue'
import HoroUpload from '@/views/horo/HoroUpload.vue'

import StoriesView from '@/views/stories/StoriesView.vue'
import StoriesEdit from '@/views/stories/StoriesEdit.vue'
import StoriesUpload from '@/views/stories/StoriesUpload.vue'
import StoriesPreview from '@/views/stories/StoriesPreview.vue'

import ProgrammingView from '@/views/programming/ProgrammingView.vue'
import ProgrammingEdit from '@/views/programming/ProgrammingEdit.vue'
import ProgrammingUpload from '@/views/programming/ProgrammingUpload.vue'

import FooterComp from "@/components/layouts/FooterComp.vue";
import LeftMenu from "@/components/LeftMenu.vue";

const routes = [
  {
    path: '/',
    name: 'home',
    components: {
      leftMenu: LeftMenu,
      default: HomeView,
      footer: FooterComp
    },
  },
  {
    path: '/login',
    name: 'login',
    components: {
      default: LoginView,
      footer: FooterComp
    },
  },
  {
    path: '/gallery',
    name: 'gallery',
    components: {
      leftMenu: LeftMenu,
      default: GalleryView,
      footer: FooterComp
    },
  },
  {
    path: '/news',
    name: 'news',
    components: {
      leftMenu: LeftMenu,
      default: NewsView,
      footer: FooterComp
    },
  },
  {
    path: '/news/edit/:id',
    name: 'news-edit',
    components: {
      leftMenu: LeftMenu,
      default: NewsEdit,
      footer: FooterComp
    },
  },
  {
    path: '/news/upload',
    name: 'news-upload',
    components: {
      leftMenu: LeftMenu,
      default: NewsUpload,
      footer: FooterComp
    },
  },
  {
    path: '/horo',
    name: 'horo',
    components: {
      leftMenu: LeftMenu,
      default: HoroView,
      footer: FooterComp
    },
  },
  {
    path: '/horo/edit/:id',
    name: 'horo-edit',
    components: {
      leftMenu: LeftMenu,
      default: HoroEdit,
      footer: FooterComp
    },
  },
  {
    path: '/horo/upload',
    name: 'horo-upload',
    components: {
      leftMenu: LeftMenu,
      default: HoroUpload,
      footer: FooterComp
    },
  },
  {
    path: '/stories',
    name: 'stories',
    components: {
      leftMenu: LeftMenu,
      default: StoriesView,
      footer: FooterComp
    },
  },
  {
    path: '/stories/edit/:id',
    name: 'stories-edit',
    components: {
      leftMenu: LeftMenu,
      default: StoriesEdit,
      footer: FooterComp
    },
  },
  {
    path: '/stories/upload',
    name: 'stories-upload',
    components: {
      leftMenu: LeftMenu,
      default: StoriesUpload,
      footer: FooterComp
    },
  },
  {
    path: '/stories/preview/:id',
    name: 'stories-preview',
    components: {
      leftMenu: LeftMenu,
      default: StoriesPreview,
      footer: FooterComp
    },
  },
  {
    path: '/programming',
    name: 'programming',
    components: {
      leftMenu: LeftMenu,
      default: ProgrammingView,
      footer: FooterComp
    },
  },
  {
    path: '/programming/edit/:id',
    name: 'programming-edit',
    components: {
      leftMenu: LeftMenu,
      default: ProgrammingEdit,
      footer: FooterComp
    },
  },
  {
    path: '/programming/upload',
    name: 'programming-upload',
    components: {
      leftMenu: LeftMenu,
      default: ProgrammingUpload,
      footer: FooterComp
    },
  },
  {
    path: '/users',
    name: 'users',
    components: {
      leftMenu: LeftMenu,
      default: UsersView,
      footer: FooterComp
    },
  },
  {
    path: '/users/edit/:id',
    name: 'users-edit',
    components: {
      leftMenu: LeftMenu,
      default: UsersEdit,
      footer: FooterComp
    },
  },
  {
    path: '/users/upload',
    name: 'users-upload',
    components: {
      leftMenu: LeftMenu,
      default: UsersUpload,
      footer: FooterComp
    },
  },
  {
    path: '/settings',
    name: 'settings',
    components: {
      leftMenu: LeftMenu,
      default: SettingsView,
      footer: FooterComp
    },
  }
]
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})


router.beforeEach((to, from, next) => {
  if (to.name !== 'login' && store.state.token === null) {
    next({ name: 'login' })
  } else next()
})

export default router
